import request from '@/utils/request'

export const login = (data) => {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export const register = (data) => {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export const getMapData = () => {
  return request({
    url: '/map/regions',
    method: 'get'
  })
}

export const getRegionDetail = (id) => {
  return request({
    url: `/map/region/${id}`,
    method: 'get'
  })
}

export const getCommunityPosts = (page = 1, limit = 10) => {
  return request({
    url: '/community/posts',
    method: 'get',
    params: { page, limit }
  })
}

export const createPost = (data) => {
  return request({
    url: '/community/post',
    method: 'post',
    data
  })
}

export const createComment = (data) => {
  return request({
    url: '/community/comment',
    method: 'post',
    data
  })
}

export const toggleLike = (postId) => {
  return request({
    url: `/community/post/${postId}/like`,
    method: 'post'
  })
}

export const uploadAudio = (formData) => {
  return request({
    url: '/dubbing/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getMasks = () => {
  return request({
    url: '/vr/masks',
    method: 'get'
  })
}
